import { render, staticRenderFns } from "./HistoryItemSkill.vue?vue&type=template&id=9b2cd8e8&scoped=true&"
import script from "./HistoryItemSkill.vue?vue&type=script&lang=js&"
export * from "./HistoryItemSkill.vue?vue&type=script&lang=js&"
import style0 from "./HistoryItemSkill.vue?vue&type=style&index=0&id=9b2cd8e8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b2cd8e8",
  null
  
)

export default component.exports